import React, { useCallback, useEffect, useState } from 'react'

import { Button, Grid, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material'
import Modal from '../../components/Modal'
import { PageTitle } from '../../components/PageElements'
import { useNotification } from '../../hooks/useNotification.js'
import { useAuth } from '../../hooks/useAuth'
import services from '../../services/index.js'

//import './style.scss'
import { Pagination } from '../../components/Table'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { trackPromise } from 'react-promise-tracker'
import TableDashboardRule from './TableDashboardRule'
import { IAiAgent, IDashboardRule } from '../../interfaces'
import { getAiAgentsPaged } from '../../services/api'
import TableAiAgents from './TableDashboardRule'

function AiAgents() {
  const { getUserRoles } = useAuth()
  const userRoles = getUserRoles()
  const { notify } = useNotification()


  const [aiAgents, setAiAgents] = useState<IAiAgent[] | []>([])

  const [newName, setNewName] = useState<string | undefined>(undefined)
  const [newAzureAgentId, setNewAzureAgentId] = useState<string | undefined>(undefined)
  const [origem, setOrigem] = useState<'snowflake' | 'fabric'>('snowflake')
  const [snowflakeDatabase, setSnowflakeDatabase] = useState<string>('')
  const [snowflakeSchema, setSnowflakeSchema] = useState<string>('')
  const [snowflakeAgent, setSnowflakeAgent] = useState<string>('')
  const [newAgentInstruction, setNewAgentInstruction] = useState<string | undefined>(undefined)
  const [modalNewItem, setModalNewItem] = useState<boolean>(false)


  const [commonSearch, setCommonSearch] = useState<string>('')
  const [orderBy, setOrderBy] = useState<string | undefined>(undefined)
  const [orderDesc, setOrderDesc] = useState<boolean>(false)
  // paginacao
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [totalCount, setTotalCount] = useState(0)


  const getAiAgents = useCallback(async () => {
    try {
      let res = await trackPromise(services.api.getAiAgentsPaged(currentPage, pageSize, orderBy, commonSearch, orderDesc))
      if (res.fail) {
        throw new Error(
          res.error || 'Não foi possível consultar os agentes'
        )
      }
      setAiAgents(res.data.data)
      setTotalCount(res.data.totalCount)
      setTotalPages(res.data.totalPages)
    } catch (error: any) {
      notify(error.message, { variant: 'error' })
    }

  }, [ orderBy, orderDesc, currentPage, pageSize, commonSearch])


  useEffect(() => {
    const init = async () => {
      await getAiAgents()
    }
    init().then()
  }, [])


  const handlePagination = async (page: number, busca: any, itemsPerPage: number) => {
    setPageSize(itemsPerPage)
    setCurrentPage(page)
  }

  const handleReload = async () => {

  }

  const handleSortOrder = (data: any) => {
    try {
      setOrderBy(data.column.key)
      setOrderDesc(data.order != 'ascend')
    } catch {
      setOrderBy(undefined)
    }
    getAiAgents()
  }

  const openNewItemModal = () => {
    setModalNewItem(true)
  }

  const closeNewItemModal = () => {
    setModalNewItem(false)
  }


  // const handleCpfCnpj = async (data:string) => {
  //   setCpfCnpj(formatCpfCnpj(data))
  //   setCpfCnpjIsValid(validarCpfCnpj(data))
  // }


  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      //getDasgboardRules()
    }, 50)

    return () => clearTimeout(delayDebounceFn)
  }, [currentPage, pageSize])


  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getAiAgents()
    }, 800)
    return () => clearTimeout(delayDebounceFn)
  }, [commonSearch])


  const createNewItem = useCallback(async () => {
    try {
      const snowflake = origem === 'snowflake'
      let data = {
        name: newName?.trim(),
        instructions: newAgentInstruction?.trim() || null,
        azureAgentId: snowflake ? null : newAzureAgentId?.trim(),
        snowflakeDatabase: snowflake ? snowflakeDatabase.trim() : null,
        snowflakeSchema: snowflake ? snowflakeSchema.trim() : null,
        snowflakeAgent: snowflake ? snowflakeAgent.trim() : null
      }
      let res = await trackPromise(services.api.createNewAiAgent(data))
      if (res.fail) {
        throw new Error(
          res.error || 'Não foi possível adicionar novo agente'
        )
      }
      window.location.href = '/app/dash_management/agents/' + res.data.id
    } catch (error: any) {
      notify(error.message, { variant: 'error' })
    }

  }, [newAgentInstruction, newName, newAzureAgentId, origem, snowflakeDatabase, snowflakeSchema, snowflakeAgent])

  const podeCriar = !!newName?.trim() && (origem === 'snowflake'
    ? !!(snowflakeDatabase.trim() && snowflakeSchema.trim() && snowflakeAgent.trim())
    : !!newAzureAgentId?.trim())


  return (
    <div className="wrapper-container-content bgwhite">
      <div className="wrapper-page-content" id="wrapper-page-content">
        <PageTitle subText={'Gerenciar agentes de IA integrados'}>
          <div>Agentes de IA</div>
        </PageTitle>

        <Grid container justifyContent="center" spacing={{ xs: 3 }}>
          <Grid item md={12} xs={12}>
            <div className="panel">
              <div className="panel-body">


                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>


                  <Button
                    variant="contained" type="button" color="secondary"
                    onClick={openNewItemModal}
                    startIcon={<AddCircleOutlineIcon fontSize="small" />}
                    //disabled={promiseInProgress}
                  >
                    <span>Novo</span>
                  </Button>


                  <TextField
                    size="small"
                    label="Buscar nos agentes"
                    placeholder="Buscar nos agentes"
                    value={commonSearch}
                    onChange={(e) => setCommonSearch(e.target.value)}
                    defaultValue=""
                  />

                </div>

                <TableAiAgents
                  data={aiAgents}
                  sortFunction={handleSortOrder}
                />

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  pageSize={pageSize}
                  itensLength={200}
                  totalCount={totalCount}
                  handlePagination={handlePagination}
                  colunaBusca={''}
                  search={''}
                />

              </div>
            </div>
          </Grid>
        </Grid>


      </div>

      <Modal
        open={modalNewItem}
        close={closeNewItemModal}
        titulo={'Novo agente'}
      >
        <Grid container spacing={{ xs: 3 }} className="sm-min-500">

          <Grid item xs={12}>

            <div className="flex justify-center">
              <TextField
                size="small"
                label="Nome do agente"
                placeholder="Nome do agente"
                value={newName}
                onChange={e => setNewName(e.target.value)}
                defaultValue=""
              />
            </div>

          </Grid>

          <Grid item xs={12}>
            <div className="flex justify-center">
              <ToggleButtonGroup size="small" exclusive value={origem}
                                 onChange={(_, v) => v && setOrigem(v)}>
                <ToggleButton value="snowflake">Snowflake (Cortex Agent)</ToggleButton>
                <ToggleButton value="fabric">Fabric (legado)</ToggleButton>
              </ToggleButtonGroup>
            </div>
          </Grid>

          {origem === 'snowflake' ? (
            <Grid item xs={12}>
              <div className="flex justify-center" style={{ gap: 8, flexWrap: 'wrap' }}>
                <TextField size="small" label="Database" value={snowflakeDatabase}
                           onChange={e => setSnowflakeDatabase(e.target.value)} />
                <TextField size="small" label="Schema" value={snowflakeSchema}
                           onChange={e => setSnowflakeSchema(e.target.value)} />
                <TextField size="small" label="Agente" value={snowflakeAgent}
                           onChange={e => setSnowflakeAgent(e.target.value)} />
              </div>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <div className="flex justify-center">
                <TextField
                  size="small"
                  label="ID do Agente (Azure)"
                  placeholder="ID do Agente (Azure)"
                  value={newAzureAgentId}
                  onChange={e => setNewAzureAgentId(e.target.value)}
                />
              </div>
            </Grid>
          )}

          <Grid item xs={12}>
            <div className="flex justify-center">
              <TextField
                size="small"
                label="Instruções"
                placeholder="Instruções"
                multiline={true}
                value={newAgentInstruction}
                onChange={e => setNewAgentInstruction(e.target.value)}
                defaultValue=""
              />
            </div>
          </Grid>

          <Grid item xs={12} className="flex justify-end gap-6">
            <Button
              variant="contained"
              color="success"
              type="button"
              size="small"
              disabled={!podeCriar}
              onClick={createNewItem}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Modal>

    </div>
  )
}

export default AiAgents
